import { IOrderItem, ITyreInfoBox } from '@wyz/types';
import { useConfig, Trans, useI18n, useLocale } from '~/common/context';

type Props = {
  orderItem: IOrderItem;
  deliveryDate: Date;
  orderType: string | null | undefined;
  supplier: string;
  customer: IUserCustomer;
};

import { Flex, FormatDeliveryDate, Text, TyreInfoBox } from '@wyz/ui';
import { DateUtils, getTyreIdentifiers } from '@wyz/utils';
import { IUserCustomer } from '~/common/types';

type TyreInformationProps = {
  tyre: ITyreInfoBox & { quantity: number };
  imageBaseUrl: string;
  supplier: string;
  deliveryDate: Date;
  orderType: string | null | undefined;
};

const TyreInformation = ({
  tyre,
  imageBaseUrl,
  supplier,
  deliveryDate,
  orderType,
}: TyreInformationProps) => {
  const { t } = useI18n();
  const { locale } = useLocale();

  return (
    <Flex direction='column'>
      <Flex direction='row' className='gap-6'>
        <div className='space-y-2'>
          <TyreInfoBox
            imageBaseUrl={imageBaseUrl}
            t={t}
            tyre={tyre}
            direction='vertical'
          />
        </div>
        <div className='space-y-2'>
          <Text weight='semi-bold' color='secondary-gray' heading='xs'>
            <Trans i18nKey='app.purchase.redistribution.pending_order.accept.initial_delivery_date' />
          </Text>
          <Text id={`initialDeliveryDate-${tyre.ean}`} weight='bold'>
            <FormatDeliveryDate
              orderType={orderType}
              backorderContent={
                <Trans i18nKey='app.common.offer_type.backorder' />
              }
              date={deliveryDate}
              format={DateUtils.DATE_FORMAT.DM}
              locale={locale}
            />
          </Text>
        </div>
        <div className='space-y-2'>
          <Text weight='semi-bold' color='secondary-gray' heading='xs'>
            <Trans i18nKey='app.purchase.redistribution.pending_order.accept.initial_supplier' />
          </Text>
          <Text id={`initialSupplier-${tyre.ean}`} weight='bold'>
            {supplier}
          </Text>
        </div>
        <div className='space-y-2'>
          <Text weight='semi-bold' color='secondary-gray' heading='xs'>
            <Trans i18nKey='app.purchase.redistribution.pending_order.accept.initial_quantity' />
          </Text>
          <Text id={`initialQuantity-${tyre.ean}`} weight='bold'>
            {tyre.quantity}
          </Text>
        </div>
      </Flex>
    </Flex>
  );
};

export default function PendingOrderTyreItem({
  orderItem,
  supplier,
  deliveryDate,
  orderType,
  customer,
}: Props) {
  const { cdnUrl } = useConfig();
  return (
    <div>
      <TyreInformation
        tyre={{
          ...orderItem,
          ...getTyreIdentifiers(
            {
              cai: orderItem.cai,
              alternativeReference: orderItem.customerReference,
              constructorReference: orderItem.customerReference,
            },
            customer.settingTemplate?.generalSetting.tyreIdentifierFields ??
              undefined,
          ),
        }}
        imageBaseUrl={cdnUrl}
        supplier={supplier}
        deliveryDate={deliveryDate}
        orderType={orderType}
      />
    </div>
  );
}
